<template>
  <div class="connect-exchanges-navigation">
    <div
        v-if="hasBackNavigation"
        class="connect-exchanges-navigation__back"
        @click.prevent="$emit('previous-step')"
    >
      <img src="@/assets/images/svg/arrows-left.svg" alt="back icon">
      <div class="connect-exchanges-navigation__back__button">back</div>
    </div>
    <BaseButton label="Connect your API Key" @click.prevent="$emit('next-step')" />
  </div>
</template>

<script>
import BaseButton from '@/components/ui/atoms/BaseButton.vue';
export default {
  name: "ConnectExchangesNavigation",
  components: { BaseButton },
  props: {
    hasBackNavigation: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.connect-exchanges-navigation {
  display: flex;
  justify-content: center;

  button {
    width: 13rem;
    height: 2rem;
    line-height: 1.8rem;
    position: relative;
    right: 3.125rem;
    font-size: 0.9rem;
    }

  &__back {
    display: flex;
    align-items: center;
    position: relative;
    right: 12rem;
    cursor: pointer;

    img {
      height: 0.7rem;
      width: 0.7rem;
    }

    &__button{
      font-size: 0.7rem;
      font-weight: 600;
    }
  }
}
@media (max-width: 768px) {
  .connect-exchanges-navigation {

    button {
      right: 1.5rem;
      font-size: 0.7rem;
      width: 16rem;
    }

    &__back {
      left: 0.6rem;
      top: 2.5rem;
      padding-bottom: 1rem;
    }
  }
}

</style>